export default __webpack_public_path__ + "static/media/m-30.19c10ff6.svg";